import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;

    .title {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }

    .iconHeader {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      cursor: pointer;
    }
  }
  
  .contentWrapper {
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    gap: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};

    .headerWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;

      .progressCircleText {
        font-size: 16px;
        font-weight: 600;
        line-height: 100%;
        color: ${({ theme }) => theme.colors.danger.danger};
      }
      
      .rightHeaderWrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .titleHeaderWrapper {
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          color: ${({ theme }) => theme.colors.surface.onSurface};
        }
    
        .descriptionHeaderWrapper {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurface};
        }
      }
    }

    .infoWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px;
      gap: 10px;
      border-radius: 6px;
      border: 1px solid ${({ theme }) => `color-mix(in srgb, ${theme.colors.information.informationOutline}, ${theme.colors.surface.surface})`};
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.information.informationContainer}, ${theme.colors.surface.surface})`};
      
      .iconInfoWrapper {
        color: ${({ theme }) => theme.colors.information.information} !important;
      }

      .textInfoWrapper {
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }

      .textInfoInfoWrapper {
        color: ${({ theme }) => theme.colors.information.information};
      }
    }
  }
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .buttonCancel {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttonConfirm {
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
    }
  }
`;
